import { render } from "./SatelliteInternetPage.vue?vue&type=template&id=fecdc4ca&ts=true"
import script from "./SatelliteInternetPage.vue?vue&type=script&lang=ts"
export * from "./SatelliteInternetPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__